import { render, staticRenderFns } from "./MainResults.vue?vue&type=template&id=8d44491a&"
import script from "./MainResults.vue?vue&type=script&lang=js&"
export * from "./MainResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports